import React, {useEffect} from 'react'
import {observer} from 'mobx-react'
import {useTranslation} from 'react-i18next'
import {Form} from 'antd'
import {Input, IconTitle} from '@/components'
import {FORM_LIMITS} from './constants'
import {DownloadPdfFormProps} from './props'

export const DownloadPdfForm: React.FC<DownloadPdfFormProps> = observer(
    ({formId, form, paymentLink, terminalSettings, onDownloadButtonClick}) => {
        const {t} = useTranslation()
        const {url, amount, currency, terminalId} = paymentLink

        const description = paymentLink?.description || ''
        const merchantName = terminalSettings?.merchantName || ''

        useEffect(() => {
            form.setFieldsValue({
                description: description,
                displayName: merchantName
            })
        }, [description, merchantName, form])

        const onFinish = async ({displayName, description}) => {
            await onDownloadButtonClick({
                url,
                amount,
                currency,
                description,
                merchantName: displayName
            })
        }

        return (
            <Form
                form={form}
                id={formId}
                layout={'vertical'}
                onFinish={onFinish}
                initialValues={{
                    description: description,
                    displayName: merchantName
                }}
                autoComplete='off'
            >
                <Form.Item
                    label={
                        <IconTitle
                            title={t('DownloadPdfForm.displayName')}
                            tooltipText={t('DownloadPdfForm.tooltip')}
                        />
                    }
                    name='displayName'
                    rules={[{required: true, message: t('DownloadPdfForm.displayNameRequired')}]}
                >
                    <Input
                        placeholder={t('DownloadPdfForm.displayName')}
                        maxLength={FORM_LIMITS.DISPLAY_NAME_MAX}
                    />
                </Form.Item>

                <Form.Item
                    name='description'
                    label={
                        <IconTitle
                            title={t('DownloadPdfForm.description')}
                            tooltipText={t('DownloadPdfForm.tooltip')}
                        />
                    }
                >
                    <Input
                        placeholder={t('DownloadPdfForm.description')}
                        maxLength={FORM_LIMITS.DESCRIPTION_MAX}
                    />
                </Form.Item>
            </Form>
        )
    }
)
